import React, { Component } from "react"
import { Card, CardBody, CardTitle, Badge, Button, Container, Row, Col, Alert } from "reactstrap"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import "flatpickr/dist/themes/material_blue.css"
import logo from "../../assets/images/site-logo.png"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { withTranslation } from "react-i18next"
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import {
  Label,
  Input,
  InputGroup,
  FormGroup,
  Nav,
  NavItem
} from "reactstrap";
import PhoneInputField from "components/Common/PhoneInput";
class RefferForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectData: '',
      formVisible: true,
      isLoading: true
    }
  }

  componentDidMount() {
    const { match: { params } } = this.props;
    const { contactId } = params;
   axios
      .get(`https://rscoreapi.azurewebsites.net/api/ContactExt/idwithagent/${contactId}`
      )
      .then((res) => {
        this.setState({ contactData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });
  }

  handleSubmit = (values, { setSubmitting }) => {
    const updateFeature = {
      title: values.title,
      notes: values.notes,
      agentId: values.agentId,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      mobile: values.mobileNo,
      leadSourceId: values.leadSourceId,
      leadTypeId: values.leadTypeId,
      contactReferralId: values.contactReferralId
    };

    toast.loading("Please wait...");
    axios.post('https://rscoreapi.azurewebsites.net/api/Lead/AddAnonymousLead', updateFeature, {
      headers: {
        'Content-Type': 'application/json',
        //'Authorization': str
      }
    })
      .then(response => {
        toast.dismiss();

        if (response.data.success) {
          //toast.success("Openhouse Saved");
          this.setState({
            formVisible: false,
            thankYouMessage: ``,
          });
        } else {
          response.data.validationErrors.forEach(error => {
            toast.error(error);
          });
        }
        // Handle success
      })
      .catch(error => {
        console.error(error);
        // Handle error
      });
  }
  formatPhoneNumber(phone) {
    if (!phone) return '';
    const cleaned = ('' + phone).replace(/\D/g, '');
    const lastTen = cleaned.slice(-10);
    const match = lastTen.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phone;
  }
  render() {
    const { formVisible, contactData, thankYouMessage, isLoading } = this.state;

    return (
      <React.Fragment>
       
        <MetaTags>
          <title>Referral | Realty Space</title>
        </MetaTags>
        <ToastContainer autoClose={2000} />
    
            <div className="headrtop">
              <div className="toppart">
                <Row>
                  <Col sm="3">
                    <div className="d-flex flex-wrap gap-2">
                      {contactData?.agentInfo?.logoFilePath ? 
                      <img src={contactData?.agentInfo?.logoFilePath} alt="" height="70px" />
                      : <img src={logo} alt="" height="70px" />}
                      
                    </div>
                  </Col>
                  <Col xl="3">


                  </Col>

                  <Col sm="6">
                    <Row>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Agent</strong><br />
                          <span>{contactData?.agentInfo?.firstName+" "+contactData?.agentInfo?.lastName	}</span>
                        </h4>
                      </Col>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Phone</strong><br />
                          <span>{contactData?.agentInfo?.agentContact?.cContact?.phone }</span>
                        </h4>
                      </Col>
                      <Col sm="4">
                        <h4 className="agentInfo"><strong>Email</strong><br />
                          <span>{contactData?.agentInfo?.primaryEmail}</span>
                        </h4>
                      </Col>
                    </Row>


                  </Col>
                </Row>

              </div>

            </div>
            <div className="page-content" style={{ paddingTop: 40 }}>

              <Container fluid>
                {formVisible ? (
                  <>
                <Row>
                  <Col xl="3"></Col>
                  <Col sm="6" className="text-center ">
                      <h2 style={{fontWeight:'bold', fontFamily:'Arial Black'}}>Refer a Friend — We`ll Take Great Care of Them</h2>
                    
                   
                    <h4 style={{ marginBottom: 10, marginTop: 0, paddingTop: 0 }}>Please share the details of someone who might be buying, selling, or investing in real estate.</h4>
                    <h4 style={{ marginBottom: 20, marginTop: 0, paddingTop: 0 }}>We`ll reach out with a warm, professional approach — no pressure, just a helpful hand.</h4>
                  </Col>
                </Row>
                <Row>
                  <Col xl="3"></Col>
                  <Col xl="6">
                    
                      <Formik
                        enableReinitialize={true}
                        initialValues={{
                          //title: '',
                          firstName: '',
                          lastName: '', 
                          email: '',
                          mobileNo: '',
                          leadSourceId:10,
                          leadTypeId: 14,
                          notes: '',  
                          acceptTerms: false,
                          contactReferralId: this.props.match.params.contactId
                        }}
                        validationSchema={Yup.object().shape({
                          //title: Yup.string().required("This is Required"),
                          firstName: Yup.string().required("This is Required"),
                          lastName: Yup.string().required("This is Required"),
                          email: Yup.string().required("This is Required"),
                          mobileNo: Yup.string().required("This is Required"),
                          acceptTerms: Yup.bool().required("You must accept the terms and conditions").oneOf([true], "You must accept the terms and conditions")
                        })}

                        onSubmit={this.handleSubmit}


                      >
                        {({ errors, touched, values, handleChange, setFieldValue }) => (
                          <Form
                            className="needs-validation"
                          >
                            <Card className="newCard">
                              <CardBody>
                                <Row>
                               
                                  <Col sm="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="firstName">
                                        {this.props.t("First Name*")}
                                      </Label>
                                      <Field
                                        name="firstName"
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.firstName && touched.firstName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="name"
                                      />
                                      <ErrorMessage
                                        name="firstName"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col sm="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="lastName">
                                        {this.props.t("Last Name*")}
                                      </Label>
                                      <Field
                                        name="lastName"
                                        type="text"
                                        className={
                                          "form-control" +
                                          (errors.lastName && touched.lastName
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="name"
                                      />
                                      <ErrorMessage
                                        name="lastName"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>


                                  <Col sm="6">
                                    <FormGroup className="mb-3">
                                      <Label htmlFor="email">
                                        {this.props.t("Email*")}
                                      </Label>
                                      <Field
                                        name="email"
                                        type="email"
                                        className={
                                          "form-control" +
                                          (errors.email && touched.email
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="email"
                                      />
                                      <ErrorMessage
                                        name="email"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                  <Col sm="6">
                                   <PhoneInputField
                                    label="Phone"
                                    name="mobileNo"
                                    value={values.mobileNo}
                                    setFieldValue={setFieldValue}
                                    error={errors.mobileNo}
                                    touched={touched.mobileNo}
                                    country="ca"
                                    required={true}
                                  />
                                  
                                  </Col>
                                  <Col sm="12">
                                      <FormGroup className="mb-3">
                                      <Label htmlFor="notes">
                                        {this.props.t("Notes (e.g., what they're looking for, timing, how you know them)")}
                                      </Label>
                                      <Field
                                        name="notes"
                                        as="textarea"
                                        className={
                                          "form-control" +
                                          (errors.notes && touched.notes
                                            ? " is-invalid"
                                            : "")
                                        }
                                        id="notes"
                                        //placeholder="Enter any additional notes here"
                                      />
                                      <ErrorMessage
                                        name="notes"
                                        component="div"
                                        className="invalid-feedback"
                                      />
                                    </FormGroup>
                                  </Col>
                                 <Col sm="12">
                                  <FormGroup className="mb-3 form-check">
                                    <Field
                                      type="checkbox"
                                      name="acceptTerms"
                                      id="acceptTerms"
                                      className={
                                        "form-check-input" +
                                        (errors.acceptTerms && touched.acceptTerms ? " is-invalid" : "")
                                      }
                                      style={{ width: '15px', height: '15px', marginRight: '4px' }}
                                    />
                                    <Label htmlFor="acceptTerms" className="form-check-label">
                                      I confirm that I have permission to share this information. I understand that the information submitted will be stored securely and used solely for the purpose of real estate follow-up. My data will not be shared or sold to third parties.
                                    </Label>
                                    <ErrorMessage
                                      name="acceptTerms"
                                      component="div"
                                      className="invalid-feedback"
                                    />
                                  </FormGroup>
                                </Col>
       
                             
                                  <Col sm="12">
                                    <button type="submit" className="btn btn-add w-md  mt-27">Submit</button>
                                  </Col>

                                </Row>

                              </CardBody>
                            </Card>

                          </Form>
                        )}
                      </Formik>
                   
                  </Col>

                </Row>
                </>
                ) : (
                <div className="text-center">
                  <h4>Thank You for the Referral!</h4>

                  <h5>I  truly appreciate your trust. Your support means a lot. Referrals are the heart of our business!</h5>
                  
                </div>
              )}
              </Container>
            </div>
         
       
      </React.Fragment>
    )
  }
}
RefferForm.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
 


}

const mapStateToProps = ({ Project }) => (
  {
    

  })
const mapDispatchToProps = dispatch => ({
 


});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RefferForm));


